<template>
  <div class="leftMon flex items-center">
    <span class="droidSerif">{{ thisMons }}</span>
    <span class="droidSerif">/</span>
    <span class="droidSerif">{{ thisDays }}</span>
  </div>
  <div class="rightLunar">
    <div class="enDate droidSerif">{{ enDate }}</div>
    <div class="lunarDate Songti">{{ thisLunar }}</div>
  </div>
  <Teleport to="#globalFooter">
    <div class="toTop" :style="{ bottom: footerShow ? `${footerScroll}px` : undefined }">
      <n-popover placement="left" trigger="hover">
        <template #trigger>
          <div class="phone">
            <img src="/src/assets/extraIcon/shouji.png" alt="shouji">
            <div class="droidSerif-bold">APP</div>
          </div>
        </template>
        <div class="qrcode-image">
          <img w-148px h-148px src="/src/assets/publicize/pc/qr.png" alt="qr">
        </div>
      </n-popover>
      <template v-if="showTop">
        <div class="top" @click="goToTop">
          <img src="/src/assets/extraIcon/jiantou.png" alt="jiantou">
          <div class="droidSerif-bold">TOP</div>
        </div>
      </template>
    </div>
  </Teleport>

</template>

<script setup lang="ts">
import { Teleport } from 'vue'
import dayjs from 'dayjs'
// @ts-ignore
import solarlunar from 'solarlunar'
import QrcodeVue from 'qrcode.vue'
import { typeViteEnv, isDev } from '@/utils/env'

const thisDays = ref()
const thisMons = ref()
const thisLunar = ref()
const enDate = ref()

const showTop = ref(false)
const footerShow = ref(false)
const footerScroll = ref(0)

const downloadPageLink = ref<string>(isDev()
  ? typeViteEnv('VITE_BASE_HOMEPAGE_URL') as string
  : location.origin + '/publicity')

function handlePublishTime() {
  const timeEl: any = document.querySelector('.c-publish-time')
  const timeVideoEl: any = document.querySelector('.video-publish .video-publish-time')
  
  if (timeEl) {
    timeEl.innerHTML = dayjs(Number(timeEl.innerHTML)).format('HH:mm, MMM DD, YYYY')
    timeEl.setAttribute('class', 'news-publish-time droidSerif')
  }
  
  if (timeVideoEl) {
    const time = timeVideoEl.innerHTML
    timeVideoEl.innerHTML = dayjs(Number(time)).format('HH:mm, MMM DD, YYYY')
    timeVideoEl.setAttribute('class', 'video-publish-time droidSerif')
  }
}

handlePublishTime()

const goToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

const handleScroll = (e) => {
  const footer: any = document.querySelector('#globalFooter')
  
  const eventTarget = e.target === document ? e.target.documentElement : e.target
  const scrollTop = eventTarget.scrollTop
  const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  const offsetTop = footer.offsetTop
  footerShow.value = (offsetTop - scrollTop) <= (viewPortHeight)
  if ((offsetTop - scrollTop) <= (viewPortHeight)) {
    footerScroll.value = viewPortHeight - (offsetTop - scrollTop) + 32
  }
  showTop.value = scrollTop > 94
}

onMounted(() => {
  nextTick(() => {
    document.addEventListener('scroll', handleScroll)
  })
  getDays()
})

// 获取当前时间渲染左上角日期
const getDays = () => {
  const currentDate = dayjs()
  thisDays.value = currentDate.format('D')
  thisMons.value = currentDate.format('M')
  const lunarDate = solarlunar.solar2lunar()
  thisLunar.value = lunarDate.gzYear + '年' + lunarDate.monthCn + lunarDate.dayCn
  enDate.value = dayjs().format('dddd')
}

</script>

<style lang="less">
.qrcode-image {
  width: 148px;
  height: 148px;
  
  canvas {
    width: 148px !important;
    height: 148px !important;
  }
}
</style>

<style lang="less" scoped>
.leftMon {
  gap: 2px;
  font-size: 32px;
  height: 32px;
  line-height: 32px;
  
  span {
    &:nth-child(2) {
      font-size: 20px;
    }
  }
}

.Songti {
  font-family: STSongti-SC-Black;
}

.rightLunar {
  font-size: 12px;
  line-height: 11px;
  
  .enDate {
    font-weight: 600;
  }
  
  .lunarDate {
    margin-top: 4px;
  }
}

.toTop {
  position: fixed;
  bottom: 39px;
  right: 28px;
  z-index: 3000;
  
  .top {
    width: 60px;
    height: 60px;
    font-size: 14px;
    font-weight: 700;
    border-radius: 1px;
    border: 1px solid #f8f8f8ff;
    display: flex;
    justify-content: center;
    align-content: center;
    text-align: center;
    flex-flow: column;
    background-color: #FFFFFF;
    box-shadow: 0 4px 8px 0 #00000014;
    cursor: pointer;
    margin-top: 12px;
    
    img {
      width: 20px;
      height: 20px;
      margin: 0 auto;
    }
  }
  
  .top:hover {
    background: #f2f2f2ff;
    box-shadow: none;
  }
  
  .phone {
    width: 60px;
    height: 60px;
    font-size: 14px;
    font-weight: 700;
    border-radius: 1px;
    border: 1px solid #f8f8f8ff;
    display: flex;
    justify-content: center;
    align-content: center;
    text-align: center;
    flex-flow: column;
    background-color: #FFFFFF;
    box-shadow: 0 4px 8px 0 #00000014;
    cursor: pointer;
    
    img {
      width: 20px;
      height: 20px;
      margin: 0 auto;
    }
  }
  
  .phone:hover {
    background: #f2f2f2ff;
    box-shadow: none;
  }
}

@keyframes dh {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
